import { z } from "zod";
import { BackdropSchema } from "../Backdrop";
import { LinkItemSchema } from "../LinkItem";
import { VisualMediaSchema } from "../Media";
import { RichTextSchema } from "../RichText";
export const MediaPromoItemSchema = z.object({
    backdrop: BackdropSchema.optional(),
    media: VisualMediaSchema.optional(),
    supertitle: z.string().optional(),
    title: z.string().optional(),
    subtitle: z.string().optional(),
    description: RichTextSchema.optional(),
    links: z.array(LinkItemSchema).optional(),
});
//# sourceMappingURL=index.js.map